import { User } from '@auth0/auth0-react';
import { createStore } from 'store-utils';

const AppStore = createStore<AppStoreState>(
  {
    initialized: false,
    loadingNewToken: true,
    generalError: false,
    pageError: false,
    authToken: undefined,
    shouldForceLogout: false,
    isFirstLogin: false,
    isReady: false,
    isEmptyOrg: true,
    user: undefined,
  },
  'App Store',
);

export interface AppStoreState {
  initialized: boolean;
  loadingNewToken: boolean;
  generalError: boolean;
  pageError: boolean;
  authToken?: string;
  shouldForceLogout: boolean;
  isFirstLogin: boolean;
  isReady: boolean;
  isEmptyOrg: boolean;
  user?: User;
}

export default AppStore;
